// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"85da5040","226":"68d757ea","277":"b80d50aa","311":"2bd7eef7","404":"ec706eeb","427":"426ff719","461":"a9bbfce3","517":"63daf34f","618":"7ac40930","665":"6f59d4db","684":"4e8f9c76","796":"28d3dcd2","881":"f605c40d","957":"fb05f580","978":"7a14df13"}[chunkId] + ".chunk.js";
};